import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBdGa6OPfRCagJolcim-8kH-TzajLdJDBw",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "akshayhotel-e2f99.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "akshayhotel-e2f99",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "akshayhotel-e2f99.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "50421294784",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:50421294784:web:eeddb15d0959cf446fef25"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Test Firebase connection
console.log('🔥 Firebase initialized successfully!');
console.log('📊 Firebase Config:', {
  projectId: firebaseConfig.projectId,
  authDomain: firebaseConfig.authDomain,
  apiKey: firebaseConfig.apiKey ? '✅ Set' : '❌ Missing'
});

// Test Firestore connection
console.log('🔍 Testing Firestore connection...');
console.log('✅ Firestore initialized successfully');

export default app;
